import React from 'react';
import { Spin } from 'antd';
import { useAtomValue } from 'jotai';
import * as atoms from '@src/components/user-management/store/atom';
import UserList from '../UserList';
import * as Styled from '@src/components/user-management/components/Main/styled';
import { ModalLayer } from '@src/components/user-management/components/ModalLayer';
import { Nav } from './Nav';
import { useGetEditorVisible, useClosePanel } from '../../hooks';
import HelpRedirect from '@src/components/common/HelpRedirect';
import { USER_MANAGEMENT_HELP } from '@src/utils/help/links';

const Main = () => {
  const visible = useAtomValue(atoms.panelVisibleAtom);
  const handleClose = useClosePanel();

  const { isVisible: isPanelVisible } = useGetEditorVisible();
  const asyncLoadingMask = useAtomValue(atoms.asyncLoadingMaskAtom);

  const renderContent = () => {
    return (
      <Styled.ContentContainer>
        <Styled.RightPanel>
          <Nav />
          <ModalLayer />
          {!isPanelVisible && <UserList />}
        </Styled.RightPanel>
      </Styled.ContentContainer>
    );
  };

  return (
    <Styled.Drawer
      open={visible}
      closeIcon={null}
      styles={{
        wrapper: {
          width: '85%',
          minWidth: '800px',
        },
        body: {
          backgroundColor: '#f6f6f6',
          padding: 0,
        },
      }}
      onClose={handleClose}
    >
      {renderContent()}
      <Styled.HelpRedirectWrapper>
        <HelpRedirect redirectUrl={USER_MANAGEMENT_HELP} />
      </Styled.HelpRedirectWrapper>
      <Styled.CloseIcon onClick={handleClose} />
      {!!asyncLoadingMask && (
        <Styled.LoadingMask>
          <Spin />
        </Styled.LoadingMask>
      )}
    </Styled.Drawer>
  );
};

export default React.memo(Main);
